import { Link } from 'react-router-dom'
import { BTN_PRIMARY } from '../lib/ui.js'
import { PAGE_FORM } from '../lib/layout.js'

const INSTALLER_URL =
  'https://raw.githubusercontent.com/jgperrin/ai.jgp.next-mcp-installer/main/install-mcp.sh'

export default function MacosInstallerPage() {
  return (
    <main className={`${PAGE_FORM} py-12`}>
      <h1 className="text-2xl font-semibold text-slate-900">
        macOS installer (deprecated)
      </h1>
      <p className="mt-3 text-sm text-slate-600">
        The macOS installer is now optional. The simpler way to add Next to
        Claude is via Settings &rarr; Connectors &rarr; Add custom connector.
        See the updated setup guide.
      </p>
      <Link
        to="/help/mcp-setup"
        className={`${BTN_PRIMARY} mt-6`}
      >
        Read the setup guide
      </Link>
      <details className="mt-8 rounded-lg border border-slate-200 bg-slate-50 p-4">
        <summary className="cursor-pointer text-sm font-semibold text-slate-700">
          I really want the installer anyway
        </summary>
        <p className="mt-3 text-sm text-slate-600">
          The legacy installer remains available for Linux power-user setups
          and older Claude Desktop versions that don&rsquo;t expose the
          custom-connector UI. Download the script directly:
        </p>
        <a
          href={INSTALLER_URL}
          download="install-mcp.sh"
          className="mt-3 inline-flex min-h-[32px] items-center rounded-full border border-slate-300 bg-white px-3 py-1 text-xs font-semibold text-slate-700 hover:bg-slate-100"
        >
          Download install-mcp.sh
        </a>
        <p className="mt-3 text-xs text-slate-500">
          Raw URL:{' '}
          <a
            href={INSTALLER_URL}
            className="underline decoration-dotted hover:text-slate-700"
          >
            {INSTALLER_URL}
          </a>
        </p>
      </details>
    </main>
  )
}
